define('home/views/ChannelModeratorFormView',[
    'underscore',
    'backbone-marionette',

    'core/strings',
    'core/UniqueModel',

    'home/models/User',
    'home/templates/channelModeratorForm',
], function (
    _,
    Marionette,

    strings,
    UniqueModel,

    User,
    channelModeratorFormTemplate
) {
    'use strict';

    var gettext = strings.get;

    /**
     * A form for adding a new moderator to a channel.
     *
     * Expects a ChannelProfile model.
     */
    var ChannelModeratorFormView = Marionette.ItemView.extend({
        template: channelModeratorFormTemplate,

        ui: {
            'username': 'input[name=username]',
            'form': 'form[data-role=channel-moderator-form]',
            'submit': 'button[type=submit]',
        },

        events: {
            'submit': 'addModerator',
            'blur input[name=username]': 'clearValidationErrors',
        },

        addModerator: function (evt) {
            if (evt)
                evt.preventDefault();

            var username = this.ui.username.val();
            var user = new UniqueModel(
                User,
                {
                    username: username,
                }
            );

            var validationError = this.model.validateNewModerator(user);
            if (validationError) {
                this.handleValidationError(this.model, validationError);
                return;
            }

            this.disableForm();

            user.moderateChannel(this.model.channel, true)
                .always(_.bind(this.enableForm, this))

                // Only clear input on success so that if there was an error
                // the user can adjust their input
                .done(_.bind(this.clearForm, this))

                .fail(_.bind(this.handleSaveError, this));
        },

        handleSaveError: function (response) {
            // Try to handle all the known error responses with proper translated messages.
            // Fall back to showing the untranslated backend error if given an unknown error.
            var responseMessage = response.responseJSON.response;
            if (/User matching query does not exist/.test(responseMessage))
                responseMessage = gettext('No user exists with that username');
            else if (/(?:You must be authenticated)|(?:You do not have admin privileges)/.test(responseMessage))
                responseMessage = gettext('You do not have permission to add moderators to this channel');

            this.handleValidationError(this.model, {
                attrName: 'username',
                message: responseMessage,
            });
        },

        /**
         * @type ValidationError
         * @property {string} attrName The attribute name that failed validation
         * @property {string} message The validation error message
         */

        /**
         * Displays the given errors on inputs designated for the attributes
         * related to the errors.
         * @param {Model} model Not used. Passed by Backbone's `invalid` event.
         * @param {ValidationError|ValidationError[]} errs An error object or array of error
         *                                                 objects with keys attrName and message.
         */
        handleValidationError: function (_model, errs) {
            if (!_.isArray(errs))
                errs = [errs];

            _.each(errs, function (err) {
                this.$('.form-attribute-input[data-attribute*=' + err.attrName + ']')
                    .addClass('is-error')
                    .find('[data-role=attribute-error]')
                    .text(err.message);
            }, this);
        },

        clearValidationErrors: function () {
            this.$('.form-attribute-input.is-error').removeClass('is-error');
        },

        clearForm: function () {
            this.ui.username.val('');
        },

        enableForm: function () {
            this.ui.form.removeClass('is-submitting');
            this.ui.submit.removeAttr('disabled');
        },

        disableForm: function () {
            this.ui.form.addClass('is-submitting');
            this.ui.submit.attr('disabled', 'disabled');
        },
    });

    return ChannelModeratorFormView;
});

